import { ListGameForm } from 'modules/games/containers';

export const ListGame = () => {
  return <ListGameForm />;
};
